import React from 'react'

const VouchersIndex = () => <div>Vouchers</div>

export default VouchersIndex
